module.exports = __webpack_public_path__ + "img/background-2-mb.f9501406.jpg";